import Cookies from 'js-cookie';

export function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift() || null;
  return null;
}

export function captureFbclidAsFbc() {
  const params = new URLSearchParams(window.location.search);
  const fbclid = params.get('fbclid');
  if (!fbclid || Cookies.get('_fbc')) {
    return;
  }

  const fbc = `fb.1.${Date.now()}.${fbclid}`;
  Cookies.set('_fbc', fbc, { expires: 90, path: '/' });
}

export function getFacebookTrackingParams() {
  captureFbclidAsFbc();

  return {
    fbp: getCookie('_fbp'),
    fbc: getCookie('_fbc'),
  };
}

export function createLeadEventId() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }

  return `lead_${Date.now()}_${Math.random().toString(36).slice(2, 11)}`;
}
